import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RsEditorConfigurationProvider } from '../../../services/rs-editor-configuration.provider';
import { CodelistModelService } from '../../../services/ui/codelist-model.service';
import { ModelListenerService } from '../../../services/view-model/model-listener.service';
import { ModelStateService } from '../../../services/view-model/model-state.service';
import { NoticeNode } from '../../../types/notice-definition';
import { ComponentModel } from '../../../view-model/component-model';
import { CodelistModel } from '../../../view-model/type/codelist-model';
import { ComponentDirective } from '../../component.directive';
import { CodelistComponent } from '../../form-components/codelist/codelist.component';
import { DialogComponent } from '../../layout/dialog/dialog.component';

@Component({
  selector: 'app-unterschwelle-wizard-dialog',
  templateUrl: './unterschwelle-wizard-dialog.component.html',
  styleUrls: ['./unterschwelle-wizard-dialog.component.scss'],
})
export class UnterschwelleWizardDialogComponent implements OnInit, AfterViewInit {

  @ViewChild(ComponentDirective, { static: true }) public view: ComponentDirective;
  @ViewChild('wizardDialog') wizardDialog: DialogComponent;

  private rsConfig = inject(RsEditorConfigurationProvider);
  private modelStateService = inject(ModelStateService);
  private codeListModelService = inject(CodelistModelService);
  private modelListenerService = inject(ModelListenerService);

  rechtsgrundlageControl = new FormControl();

  codeListBt01c: { id: string; label: string }[];

  codeListBt105Model: CodelistModel;

  async ngOnInit(): Promise<void> {
    if (!this.shouldShowWizard()) {
      return;
    }

    // TODO: muss eigentlich im SDK getailored werden, aus Zeitgruenden derzeit allerdings nicht moeglich
    this.codeListBt01c = (await this.codeListModelService.loadStandardCodeList('BT-01(c)-Procedure'))
      .filter(item => ['vob-a', 'uvgo'].includes(item.id));

    this.codeListBt105Model = new CodelistModel();
    this.codeListBt105Model.noticeNode = { id: 'BT-105-Procedure' } as NoticeNode;
    this.codeListBt105Model.root = { noticeId: this.rsConfig.getSubTypeId() } as ComponentModel;
    this.codeListBt105Model.codeList = await this.codeListModelService.loadStandardCodeList(this.codeListBt105Model.noticeNode.id);

    const codelistComponent = this.view.viewContainerRef.createComponent(CodelistComponent).instance;
    codelistComponent.ignoreModelValueChanges = true;
    codelistComponent.initWithModel(this.codeListBt105Model);
  }

  ngAfterViewInit(): void {
    if (this.shouldShowWizard()) {
      this.wizardDialog.openDialog();
    }
  }

  private shouldShowWizard(): boolean {
    return ['E3', 'E4'].includes(this.rsConfig.getSubTypeId()) && !this.rsConfig.getRsNoticeId() && !this.rsConfig.getRsTemplateId() && !this.rsConfig.getBaseRsNoticeId();
  }

  onAccept(): void {
    if (this.rechtsgrundlageControl?.value?.id) {
      const bt01Model = ModelStateService.findModelById(this.modelStateService.componentModel, 'BT-01(c)-Procedure') as CodelistModel;
      bt01Model.value = this.rechtsgrundlageControl?.value?.id;
      this.modelListenerService.onModelValueChange(bt01Model);
    }

    if (this.codeListBt105Model.value) {
      const bt105Model = ModelStateService.findModelById(this.modelStateService.componentModel, 'BT-105-Procedure') as CodelistModel;
      bt105Model.value = this.codeListBt105Model.value;
      this.modelListenerService.onModelValueChange(bt105Model);
    }
  }

}
